import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32250eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal rounded",
  id: "myModalCompetitor",
  "data-target": ".bd-example-modal-lg"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header p-4",
  style: {"gap":"1rem","display":"flex"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div style=\"background-color:aliceblue;width:2rem;height:2rem;border-radius:8px;display:flex;align-items:center;justify-content:center;\" data-v-32250eda><svg width=\"70\" height=\"70\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32250eda><rect width=\"40\" height=\"40\" rx=\"10\" fill=\"#F9F9F9\" data-v-32250eda></rect><g clip-path=\"url(#clip0_279_226)\" data-v-32250eda><path opacity=\"0.3\" d=\"M20.0001 25H13.2605V18.75H11.014V28.75C11.014 29.4414 11.516 30 12.1373 30H21.1233C21.7446 30 22.2466 29.4414 22.2466 28.75V18.75H20.0001V25ZM31.0431 15.5547L28.0489 10.5547C27.8383 10.207 27.4873 10 27.1117 10H12.8884C12.5129 10 12.1618 10.207 11.9547 10.5547L8.96055 15.5547C8.4621 16.3867 8.99565 17.5 9.89426 17.5H30.1094C31.0045 17.5 31.538 16.3867 31.0431 15.5547ZM26.7396 29.375C26.7396 29.7188 26.9923 30 27.3012 30H28.4245C28.7334 30 28.9861 29.7188 28.9861 29.375V18.75H26.7396V29.375Z\" fill=\"#203972\" data-v-32250eda></path><path d=\"M31.043 15.5547L28.0488 10.5547C27.8382 10.207 27.4872 10 27.1116 10H12.8883C12.5127 10 12.1617 10.207 11.9546 10.5547L8.96043 15.5547C8.46198 16.3867 8.99553 17.5 9.89414 17.5H30.1093C31.0044 17.5 31.5379 16.3867 31.043 15.5547Z\" fill=\"#203972\" data-v-32250eda></path></g><defs data-v-32250eda><clipPath id=\"clip0_279_226\" data-v-32250eda><rect width=\"22.4652\" height=\"25\" fill=\"white\" transform=\"translate(8.7674 7.5)\" data-v-32250eda></rect></clipPath></defs></svg></div><div class=\"d-flex justify-content-between align-items-center col-8\" data-v-32250eda><h5 class=\"modal-title col-6\" style=\"font-size:1rem;\" data-v-32250eda>Vincular Vendedores a Loja</h5></div>", 2)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-file-import",
  "aria-hidden": "true",
  style: {"font-size":"1.1rem","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.8rem","font-weight":"600","margin-bottom":"1rem","color":"var(--cor_texto_2)"} }, "x", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "modal-body d-flex flex-column",
  style: {"background-color":"#D9D9D9","gap":"1rem","padding":"1rem","border-radius":"0rem  0rem 0.475rem 0.475rem"}
}
const _hoisted_11 = {
  class: "col-md-12",
  style: {"border-radius":"8px","background-color":"#ffffff","display":"flex","padding":"1rem","gap":"1rem"}
}
const _hoisted_12 = {
  class: "col-md-6 d-flex flex-column justify-content-start align-items-start",
  style: {"border-right":"1px solid #D9D9D9"}
}
const _hoisted_13 = { style: {"font-size":"1.2rem","font-weight":"500","margin-bottom":"0"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1rem","font-weight":"400","margin-bottom":"0","opacity":"0.8"} }, "Loja", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"80%","width":"1px"} }, null, -1))
const _hoisted_16 = {
  class: "col-md-6 d-flex align-items-center justify-content-start",
  style: {"gap":"1rem"}
}
const _hoisted_17 = { style: {"font-size":"1.5rem","margin-bottom":"0","font-weight":"600"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"1rem","margin-bottom":"0","font-weight":"500"} }, "Vendedores vinculados", -1))
const _hoisted_19 = {
  class: "col-md-12 p-0 h-100 flex-column",
  style: {"border-radius":"8px","background-color":"#ffffff","display":"flex","padding":"1rem"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12 d-flex justify-content-between align-items-center",
  style: {"padding":"1rem","border-bottom":"1px solid #D9D9D9"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Vendedores vinculados"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Ações")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Esta loja não possui vinculo")
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { style: {"min-height":"4rem"} }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"font-size":"1.1rem","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "btn btn-sm background_btn_1_opct",
  type: "button",
  disabled: ""
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 1,
  class: "btn btn-sm background_btn_1",
  type: "button",
  disabled: "",
  style: {"height":"3rem","width":"12rem","font-size":"1rem","color":"#ffffff"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_37 = {
  class: "modal",
  tabindex: "-1",
  id: "myModalCompetitorNotValidCpf"
}
const _hoisted_38 = { class: "modal-dialog" }
const _hoisted_39 = { class: "modal-content row g-4" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header pt-4 pb-4\" data-v-32250eda><div class=\"w-100 d-flex justify-content-start align-items-center\" data-v-32250eda><h5 class=\"modal-title\" data-v-32250eda>Verifique os dados antes de cadastrar</h5></div><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" style=\"background-color:transparent;border:none;\" data-v-32250eda><span style=\"font-size:1.8rem;font-weight:600;margin-bottom:1rem;color:var(--cor_texto_2);\" data-v-32250eda>x</span></button></div>", 1)
const _hoisted_41 = { class: "modal-body" }
const _hoisted_42 = {
  key: 0,
  class: "card form-group"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-muted ps-4" }, "CPFs não válidos:", -1))
const _hoisted_44 = { class: "list-group list-group-flush" }
const _hoisted_45 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_46 = { class: "card form-group mt-4" }
const _hoisted_47 = {
  key: 0,
  class: "form-check-label text-muted ps-4"
}
const _hoisted_48 = { class: "list-group list-group-flush" }
const _hoisted_49 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_50 = {
  key: 1,
  class: "card form-group mt-4"
}
const _hoisted_51 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label ps-4 text-muted col-10" }, "CPFs válidos:", -1))
const _hoisted_53 = {
  key: 0,
  class: "fa fa-chevron-down pe-2",
  "aria-hidden": "true",
  style: {"font-size":"1.1rem","color":"red","margin":"0","padding":"0"}
}
const _hoisted_54 = {
  key: 1,
  class: "fa fa-chevron-up pe-2",
  "aria-hidden": "true",
  style: {"font-size":"1.1rem","color":"red","margin":"0","padding":"0"}
}
const _hoisted_55 = { class: "row px-4" }
const _hoisted_56 = { class: "col-6 p-2 customInput3i324uyiu342y23iu" }
const _hoisted_57 = { class: "modal-footer" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Fechar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadPlanilhas = _resolveComponent("UploadPlanilhas")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_UploadPlanilhas, {
                openClose: _ctx.dialogVisible,
                inforStore: _ctx.ownRelationInfo,
                onUpdateArrayNotValid: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateArrayNotValid($event)))
              }, null, 8, ["openClose", "inforStore"]),
              _hoisted_5,
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-sm background_btn_1_opct col-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = !_ctx.dialogVisible)),
                style: {"height":"3rem","width":"12rem","font-size":"1rem","color":"#ffffff"}
              }, [
                _hoisted_7,
                _createTextVNode(" Importar Excel ")
              ]),
              _createElementVNode("button", {
                type: "button",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetSelectValues && _ctx.resetSelectValues(...args))),
                ref: "refModalDel",
                style: {"background-color":"transparent","border":"none"}
              }, _hoisted_9, 512)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.relationData?.fantasy_name), 1),
                  _hoisted_14
                ]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.lenghtRealation), 1),
                  _hoisted_18
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                (_ctx.relationDataInfo.length === 0 && _ctx.isLoading === false? true: false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                  : _createCommentVNode("", true),
                (!_ctx.isLoading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.relationDataInfo, (user) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_openBlock(), _createElementBlock("div", {
                          key: user?.id,
                          class: "col-md-12 d-flex justify-content-between align-items-center",
                          style: {"padding":"1rem"}
                        }, [
                          _createElementVNode("span", null, _toDisplayString(user.name? user.name : _ctx.formatCPF(user?.cpf_competitor)), 1),
                          (!_ctx.isLoadingButton)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-sm background_btn_1_opct",
                                onClick: ($event: any) => (_ctx.deletRelation(user?.cpf_competitor))
                              }, _hoisted_30, 8, _hoisted_28))
                            : _createCommentVNode("", true),
                          (_ctx.isLoadingButton)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_31, _hoisted_33))
                            : _createCommentVNode("", true)
                        ]))
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("form", {
                class: "modal-footer d-flex flex-row justify-content-between rounded",
                style: {"padding":"1rem","background-color":"#ffffff"},
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitFunction && _ctx.onSubmitFunction(...args)), ["prevent"]))
              }, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.value1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value1) = $event)),
                  class: "col-md-9",
                  clearable: "",
                  type: "text",
                  name: "form-store-post-telefone",
                  id: "form-store-post-telefone",
                  placeholder: "Digite os cpfs dos novos vendedores"
                }, null, 8, ["modelValue"]),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      class: "btn btn-sm background_btn_1",
                      disabled: _ctx.value1.length === 0? true : false,
                      style: {"height":"3rem","width":"12rem","font-size":"1rem","color":"#ffffff"}
                    }, "Adicionar", 8, _hoisted_34))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_35, [
                      _hoisted_36,
                      _createTextVNode(" Loading... ")
                    ]))
                  : _createCommentVNode("", true)
              ], 32)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            (_ctx.arrayNotValid.some(elem => elem.status === 'error'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _hoisted_43,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayNotValid, (elem, index) => {
                    return (_openBlock(), _createElementBlock("ul", _hoisted_44, [
                      (elem.status === 'error')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                            _withDirectives(_createVNode(_component_el_input, {
                              type: "text",
                              placeholder: elem.cpf,
                              modelValue: elem.cpf,
                              "onUpdate:modelValue": ($event: any) => ((elem.cpf) = $event),
                              class: "col-6 form-control p-0",
                              size: "small",
                              style: {"border-color":"var(--cor_indicadores_4) !important"}
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]), [
                              [_directive_maska, {mask:'###.###.###-##'}]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              (_ctx.arrayNotValid.some(elem => elem.status === 'warnning'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_47, "CPFs já cadastrados:"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayNotValid, (elem, index) => {
                return (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                  (elem.status === 'warnning')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                        _withDirectives(_createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          placeholder: elem.cpf,
                          modelValue: elem.cpf,
                          "onUpdate:modelValue": ($event: any) => ((elem.cpf) = $event),
                          class: "col-12 form-control p-0",
                          size: "small",
                          style: {"border-color":"var(--cor_indicadores_3) !important"}
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]), [
                          [_directive_maska, {mask:'###.###.###-##'}]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
            ]),
            (_ctx.arrayNotValid.some(elem => elem.status === 'sucess'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("div", {
                      class: "col-1 d-flex justify-content-end",
                      style: {"cursor":"pointer"},
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCpfValidation = !_ctx.showCpfValidation))
                    }, [
                      (!_ctx.showCpfValidation)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_53))
                        : _createCommentVNode("", true),
                      (_ctx.showCpfValidation)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_54))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    (_ctx.showCpfValidation)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.arrayNotValid.filter(elem => elem.status === 'sucess'), (elem, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _withDirectives(_createVNode(_component_el_input, {
                              disabled: "",
                              type: "text",
                              placeholder: elem.cpf,
                              modelValue: elem.cpf,
                              "onUpdate:modelValue": ($event: any) => ((elem.cpf) = $event),
                              size: "small"
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]), [
                              [_directive_maska, {mask:'###.###.###-##'}]
                            ])
                          ]))
                        }), 256))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn background_btn_1",
              style: {"color":"white"},
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmitFunctionOnValidation && _ctx.onSubmitFunctionOnValidation(...args)))
            }, "Confirmar")
          ])
        ])
      ])
    ])
  ], 64))
}